export interface PostAuthorModel { 
  avatarImageId: string,
  name: string,
  userId: string,
}

export interface PostModel { 
  createdOn: number,
  discussionGroupId: string,
  id: string,
  messageBody: string,
  parentId: string|null,
  author: PostAuthorModel,
  replies: PostModel[],
  selected: string,
  courseInfo: {
    name: string,
    id: string
  }
}

export interface GetReportsResponse {
  reports: ReportDTO[];
}

export interface ReportDTO {
  id: string;
  reporterId: string;

  moderationSource: ModerationSource;
  contentId: string;
  contentBody: string;
  contentAuthorId: string;
  riskVector: RiskVector;

  reportCategories: FilterCheckOutputCategory[];
  status: ReportModerationStatus;
  moderationLog: ModerationAction[];

  course?: string;

  createdOn: Date;
  updatedOn: Date;
}

export interface RiskVector {
  checksOutputs: FilterCheckOutput[];

  producedAt: Date;
  serviceVersion: string;
}

export interface ModerationAction {
  moderatorId: string;

  actionType: ModerationActionType;
  actionDescription: string;
  proposedReportCategories: FilterCheckOutputCategory[];

  createdAt: Date;
}

export enum ModerationActionType {
  CATEGORIES_UPDATE = 'CATEGORIES_UPDATE',

  UPDATE_AS_SAFE = 'UPDATE_AS_SAFE',

  USER_BAN = 'USER_BAN',
  USER_ESCALATE = 'USER_ESCALATE',

  REPORT_RESOLVE = 'REPORT_RESOLVE',
}

export const enum FilterCheckType {
  OBSCENITY = 'OBSCENITY',
  SUICIDE_IDEATION = 'SUICIDE_IDEATION',
  TRIGGERING_WORDS = 'TRIGGERING_WORDS',
  GREETING = 'GREETING',
  OPEN_AI = 'OPEN_AI',
}

export interface FilterCheckOutput {
  type: FilterCheckType;
  outputData: KeywordFilterOutput | OpenAIResult | null;
  categories: FilterCheckOutputCategory[];
}

export interface OpenAIResult {
  categories: {
    hate: boolean;
    'hate/threatening': boolean;
    'self-harm': boolean;
    sexual: boolean;
    'sexual/minors': boolean;
    violence: boolean;
    'violence/graphic': boolean;
  };
  category_scores: {
    hate: number;
    'hate/threatening': number;
    'self-harm': number;
    sexual: number;
    'sexual/minors': number;
    violence: number;
    'violence/graphic': number;
  };
  flagged: boolean;
}

export interface KeywordFilterOutput {
  matchedWords: string[];
}

export enum ModerationSource {
  DISCUSSION_POST = 'DISCUSSION_POST',
  COMMUNITY_USER_NAME = 'COMMUNITY_USER_NAME',
}

export enum ReportModerationStatus {
  AUTO_RESOLVED = 'AUTO_RESOLVED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
}

export enum FilterCheckOutputCategory {
  SAFE = 'SAFE',
  GREETING = 'GREETING',
  OBSCENITY = 'OBSCENITY',
  SUICIDAL_IDEATION = 'SUICIDAL_IDEATION',
  TRIGGERING = 'TRIGGERING',
  HATE = 'HATE',
  THREATENING = 'THREATENING',
  SELF_HARM = 'SELF_HARM',
  SEXUAL = 'SEXUAL',
  SEXUAL_MINORS = 'SEXUAL_MINORS',
  VIOLENCE = 'VIOLENCE',
  VIOLENCE_GRAPHIC = 'VIOLENCE_GRAPHIC',
  SPAMMY = "SPAMMY",
  BULLYING = "BULLYING",
  MISINFORMATION = "MISINFORMATION",
  TROLLING = "TROLLING",
  ASKS_OR_PROVIDES_PERSONAL_INFORMATION = "ASKS_OR_PROVIDES_PERSONAL_INFORMATION",
}
